import { createFileRoute } from '@tanstack/react-router';
import { ClientRegisterTable } from '@/components/company/clients/table/client-table';

export const Route = createFileRoute('/(app)/company/clients/')({
  component: CompanyClientsRoute,
});

function CompanyClientsRoute() {
  return <ClientRegisterTable />;
}
